import SecureVideoPlayer from "../components/SecureVideoPlayer";
import logger from "../utils/logger";

export const LiveStreamPlayer = () => {
  // const videoRef = useRef<HTMLVideoElement | null>(null);

  // useEffect(() => {
  //   if (Hls.isSupported()) {
  //     const hls = new Hls();
  //     hls.loadSource("https://192.168.10.123:4001/hls/court.m3u8");
  //     if (videoRef.current) {
  //       hls.attachMedia(videoRef.current);
  //     }
  //   }
  // }, []);
  // const videoUrl = {
  //   url: "https://192.168.10.123:4000/api/archival/playVideo",
  //   token:
  //     "tVaTuzcoBj0iZ_Qk2l7Ai2zvE8ktq8rqhwLnoFQ86wbD61zZWwD5DKoV18C585p0W4JJcdgo0mM-1dkC79Gm3--2lZRR6FK_MOHdjeg40SP4kUixoXhYAeYqjCCoBkSduhZeyiwKB6o-62pUqawcg_AQa1N2beZIjtb7TWhUEFg2y82h8rfB4fG08LpG-85V_3pdfX0CjmPGtTkrwo1_jp45UgoWVmXH8v4chqdLbu8Z5W-onI9Dph-4vYNrF-TdgpN1T27WIq5ie1BjSdmxrkmpPPCDOuvrFwROY1WWXuaAxzIeXC0cT6hp6pzki0k2tUxS5gS5dcVT8mycy-wZ_5QZD46m6mgk25IR4cXK7W8l-o5JRSlnQkKb9Af2RqFKS-Ii2q8RoXOP46Bg0B6MEYnKt9AND6T6H0bkl1w0cirb6WzuLsGTKo_SXc0iQ-K8cDrmFlAppBn_93NiCi7bP3zk_bkH6BJTamp3ZBH5yMX4j8yaKaEAl54AowTDk61VB3sEQBtgIublDX7JPCVEmfA",
  // };
  logger.log("aa");

  // return <video ref={videoRef} controls autoPlay />;
  return <SecureVideoPlayer />;
};
